<script>
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import TermRow from "@/components/term-row";
import { servicehelpers } from "../../services/servicehelpers";
// import { paymenttermService } from "../../services/paymentservice/paymentterm.service";
import { loanTemplateService } from "../../services/paymentservice/loantemplate.service";
import i18n from "../../i18n";

/* eslint-disable no-console */
/**
 * Item List component
 */
export default {
  components: {
    Input,
    Select,
    TermRow,
  },
  data() {
    return {
      valueName: '',
      valueNameEn: '',
      valuePeriod: '',
      valuePeriodType: 0,
      valueRoundingRoule: 0,

      termRowList: [],

      typeList: {},
      periodTypeList: {},
      roundingRouleList: {},
      loanTypeList: {},
      loanTemplateList: {},

      lastPrice: 0
    };
  },
  mounted() {

    this.loadingTermData();
    this.loadingRoundingRuleData();
    this.loadingLoanTypeData();
    this.loadingPaymentTermTypeData();
    this.loadingLoanTemplateData();

    this.valuePeriodType = 2;
    this.valueRoundingRoule = 1;

    this.lastPrice = this.salePrice - this.discount;
    
  },
  methods: {
    show: function() {
      this.$refs[this.id].show();
    },
    reset: function() {
      this.valueName = '';
      this.valueNameEn = '';
      this.valuePeriod = '';
      this.valuePeriodType = 0;
      this.valueRoundingRoule = 0;

      this.termRowList = [];
    },
    getTitle: function() {
      
      return `${i18n.t('setting.property.payment-term.text')}`
    },

    getStatus: function() {
      return this.item != null && this.item.status.replace("<br/><div style=\"font-size: 6.5pt; margin-top: 5px;\">", "  ").replace("</div>", " ");
    },

    getPrice: function() {
      return  this.item != null && this.filters.numFormat(this.item.price, `0,0.00`);
    },

    loadingTermData: function() {

      servicehelpers.getTermData().then(response => {
        this.periodTypeList = response;
      });
    },

    loadingPaymentTermTypeData: function() {

      servicehelpers.getPaymentTermTypeData().then(response => {
        this.typeList = response;
      });
    },

    loadingRoundingRuleData: function() {

      servicehelpers.getRoundingRuleData('?page=0').then(response => {
        this.roundingRouleList = response;
      });
    },

    loadingLoanTypeData: function() {

      servicehelpers.getLoanTypeData('?page=0').then(response => {
        this.loanTypeList = response;
      });
    },

    loadingLoanTemplateData: function() {

      loanTemplateService.getList('?page=0')
        .then(response => {
          this.loanTemplateList = response;
        });
    },

    generateTerm: function() {

      this.termRowList = [];
      // this.termRowList.clear();

      setTimeout(() => {
        
        //let lastPrice = this.salePrice - this.discount;
        for(let i=0; i<this.valuePeriod; i++) {

          if(i == this.valuePeriod-1) {

            this.termRowList.push({
              amount: "*",
              show: "*",
              type: 3,

            });

          } else {
            this.termRowList.push(null);
          } 
        }
      }, 50);

    },

    getAllRecords: function() {

      // console.log(JSON.stringify(this.$refs));

      let list = [];
      Object.keys(this.$refs).map(el => {
        if(this.$refs[el][0] !== undefined && 'getResult' in this.$refs[el][0]) {
          
          let term = (this.$refs[el][0]).getResult();
          list.push(term);
        }
      });

      if(this.modal) {
        this.$refs['payment-term'].hide();
      }

      return {
        name: this.valueName,
        name_en: this.valueNameEn,
        period: this.valuePeriod,
        payment_period_type: this.valuePeriodType,
        rounding_rule_id: this.valueRoundingRoule,
        for_sale: 1,
        is_customized: 0,
        list: list,
        payment_term_details: list
      };
    },

    termRowChanged: function() {
      // console.log(event);
      if(this.modal) {
        let lastPrice = 0;
        Object.keys(this.$refs).map(el => {
          if(this.$refs[el][0] !== undefined && 'getValue' in this.$refs[el][0]) {
            
            let term = (this.$refs[el][0]).getValue();
            if(term != '*') {
              if(term.includes("%")) {
                let amount = parseFloat(term.replace('%', ''));
                lastPrice += this.salePrice * amount / 100;

                // console.log("PP");
                
              } else {
                let amount = parseFloat(term);
                lastPrice += amount;

                // console.log("AM", amount);
              }
            } else {
              console.log(el);
            }

            // console.log(lastPrice);
          }
        });

        (this.$refs[`terms_${this.termRowList.length - 1}`][0]).setValue(this.salePrice - lastPrice);
      }
    
    },

    getTerms: function() {
      let list = [];
      Object.keys(this.$refs).map(el => {
        if(this.$refs[el][0] !== undefined && 'getResult' in this.$refs[el][0]) {
          
          let term = (this.$refs[el][0]).getResult();
          delete term.index;
          delete term.installment_payment;

          list.push(term);
        }
      });

      return {
        name: this.valueName,
        name_en: this.valueName,
        label: this.valueName,
        period: this.valuePeriod,
        payment_period_type: this.valuePeriodType,
        rounding_rule_id: this.valueRoundingRoule,
        for_sale: 1,
        is_customized: 0,
        payment_term_details: list
      };
    },

    submitSave: function() {

      // let list = [];
      // Object.keys(this.$refs).map(el => {
      //   if(this.$refs[el][0] !== undefined && 'getResult' in this.$refs[el][0]) {
          
      //     let term = (this.$refs[el][0]).getResult();
      //     delete term.index;
      //     delete term.installment_payment;

      //     list.push(term);
      //   }
      // });

      // // console.log(JSON.stringify(list));

      // let term = {
      //   // id: 99,
      //   name: this.valueName,
      //   name_en: this.valueName,
      //   period: this.valuePeriod,
      //   payment_period_type: this.valuePeriodType,
      //   rounding_rule_id: this.valueRoundingRoule,
      //   for_sale: 1,
      //   is_customized: 0,
      //   payment_term_details: list
      // };

      let term = this.getTerms();

      if(this.modal) {
        term['id'] = 99;
        this.$refs['payment-term'].hide();
        this.$emit('save', term);
      } else {
        console.log(JSON.stringify(term));
        // paymenttermService.insert(term)
        //  .then(response => {
        //    if(response.status == 200) {
        //       term['id'] = response.data.id;
            
        //       this.$refs['payment-term'].hide();
        //       this.$emit('save', term);
        //    } 
        // });
      }
    
    },

    submitCancel: function() { 

      // console.log(this.$refs['term'].getResult());

      Object.keys(this.$refs).map(el => {
        
        if(this.$refs[el][0] !== undefined && 'getResult' in this.$refs[el][0]) {
  
            console.log((this.$refs[el][0]).getResult());
        }

        // if(el != 'customer-form') {
        //   if('getResult' in this.$refs[el]) {
        //     let term = (this.$refs[el][0]).getResult();
        //     console.log(term);

        //   }
        // }
      });
    },

  },
  props: {
    id: {
      type: String,
    },
    modal: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object,
    },
    title: {
      type: String,
    },
    filters: null,  
    selectChangePaymentTerm: null,
    amount: {
      type: Number,
      default: 0
    },
    salePrice: {
      type: Number,
      default: 0
    },
    discount: {
      type: Number,
      default: 0
    }
  },
};
</script>
<template>
  <div>
    <div v-if="modal">
      <b-modal
        :id="id"
        :ref="id"
        centered
        size="xl"
        :title='getTitle()'
        title-class="font-22"
        hide-footer
        :hide-header-close="true"
      >
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <Input 
                      :type="'text'"
                      :id="'name'"
                      v-model="valueName"
                      :label="'setting.property.payment-term.description'" 
                      /> 
                  </div>
                  <!-- <div class="col-md-3">
                    <Input 
                      :type="'text'"
                      :id="'name_en'"
                      v-model="valueNameEn"
                      :label="'setting.property.payment-term.name_en'" 
                      /> 
                  </div> -->
                  <div class="col-md-2">
                    <Input 
                      :type="'number'"
                      :id="'period'"
                      v-model="valuePeriod"
                      @leave="generateTerm"
                      :label="'setting.property.payment-term.period'" 
                      /> 
                  </div>
                  <div class="col-md-2">
                    <Select 
                      :id="'period_type'"
                      :text="'number'"
                      :text2="'number_en'"
                      :disabled="true"
                      v-model="valuePeriodType"
                      :list="this.periodTypeList"
                      :label="'setting.property.payment-term.period_type'"
                     /> 
                  </div>
                  <div class="col-md-2">
                    <Select 
                      :text="'name'"
                      :id="'rounding_rule'"
                      v-model="valueRoundingRoule"
                      :list="this.roundingRouleList"
                      :label="'setting.property.payment-term.rounding_rule'"  />
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    {{$t('setting.property.payment-term.amount')}}
                  </div>
                  <div class="col-md-3">
                    {{$t('setting.property.payment-term.installment_payment')}}
                  </div>
                  <div class="col-md-3">
                    {{$t('setting.configuration.loan-template.text')}}
                  </div>
                </div>
                <div class="row" style="height: 15px;"></div>
                <div>
                  <TermRow v-for="(term, index) in termRowList" :key="index" 
                    @input="termRowChanged"
                    :ref="`terms_${index}`"
                    :index="index"
                    :loanTypeData="loanTemplateList"
                    :typeData="typeList"
                    :test="`terms_${index}`"
                    :term="term"
                  />
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">

            <div class="row">
              <div class="col"></div>
              <div class="col-auto" style="margin-top: -40px; margin-right: 20px; margin-bottom: 10px;">
                <b-button type="button" variant="primary" class="btn-block" @click="submitSave()">
                  <i v-bind:class="'bx bx-save bx-tada font-size-18 align-middle me-2'" ></i>
                  {{$t('general.save')}}
                </b-button>
              </div>
            </div>

          </div>
        </div>
      </b-modal>
    </div>
    <div v-else>
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <Input 
                      :type="'text'"
                      :id="'name'"
                      v-model="valueName"
                      :label="'setting.property.payment-term.description'" 
                      /> 
                  </div>
                  <!-- <div class="col-md-3">
                    <Input 
                      :type="'text'"
                      :id="'name_en'"
                      v-model="valueNameEn"
                      :label="'setting.property.payment-term.name_en'" 
                      /> 
                  </div> -->
                  <div class="col-md-2">
                    <Input 
                      :type="'number'"
                      :id="'period'"
                      v-model="valuePeriod"
                      @leave="generateTerm"
                      :label="'setting.property.payment-term.period'" 
                      /> 
                  </div>
                  <div class="col-md-2">
                    <Select 
                      :id="'period_type'"
                      :text="'number'"
                      :text2="'number_en'"
                      :disabled="true"
                      v-model="valuePeriodType"
                      :list="this.periodTypeList"
                      :label="'setting.property.payment-term.period_type'"
                     /> 
                  </div>
                  <div class="col-md-2">
                    <Select 
                      :text="'name'"
                      :id="'rounding_rule'"
                      v-model="valueRoundingRoule"
                      :list="this.roundingRouleList"
                      :label="'setting.property.payment-term.rounding_rule'"  />
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    {{$t('setting.property.payment-term.amount')}}
                  </div>
                  <div class="col-md-3">
                    {{$t('setting.property.payment-term.installment_payment')}}
                  </div>
                  <div class="col-md-3">
                    {{$t('setting.configuration.loan-template.text')}}
                  </div>
                </div>
                <div class="row" style="height: 15px;"></div>
                <div>
                  <TermRow v-for="(term, index) in termRowList" :key="index" 
                    @input="termRowChanged"
                    :ref="`terms_${index}`"
                    :index="index"
                    :loanTypeData="loanTemplateList"
                    :typeData="typeList"
                    :test="`terms_${index}`"
                    :term="term"
                  />
                </div>

              </div>
            </div>
          </div>
        </div>

    </div>
  </div>
</template>